(async () => {
  const { default: Swiper, Navigation } = await import("swiper");

  Swiper.use([Navigation]);

  class PageCategoryNav extends HTMLElement {
    constructor() {
      super();

      this.swiperElement = this.querySelector("[data-swiper-page-category-nav]");
      this.buttonPrev = this.querySelector(".swiper-button-prev");
      this.buttonNext = this.querySelector(".swiper-button-next");
      this.swiperOptions = {
        loop: false,
        observer: true,
        threshold: 10,
        slidesPerView: "auto",
        direction: "horizontal",
        navigation: {
          nextEl: this.buttonNext,
          prevEl: this.buttonPrev,
        },
        breakpoints: {
          360: {
            slidesOffsetBefore: 8,
            slidesOffsetAfter: 8,
          },
          768: {
            slidesOffsetBefore: 0,
            slidesOffsetAfter: 0,
          },
        },
      };

      this.init();
    }
    init() {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

      if (Shopify.designMode && this.swiperInstance) {
        const sectionSettings = JSON.parse(
          this.closest("[data-shopify-editor-section]").dataset.shopifyEditorSection,
        );

        window.addEventListener("shopify:section:load", () => {
          this.swiperInstance.update();
        });

        window.addEventListener("shopify:block:select", (event) => {
          if (event.detail.sectionId === sectionSettings.id) {
            // extra check to see if we're in the right section, because the event listener is added to the window and might fire for multiple sections.
            this.swiperInstance.update();
            this.handleThemeEditorEvents(event);
          }
        });
      }
    }

    /**
     * Handles the theme editor block change/edit event
     * @param {Object} event
     */
    handleThemeEditorEvents(event) {
      // Slide to slide based on the data attribute from the target and add 1 to get the slide index
      this.swiperInstance.slideTo(parseInt(event.target.dataset.swiperSlideIndex) + 1);
    }
  }

  window.PageCategoryNav = PageCategoryNav;

  customElements.define("page-category-nav", PageCategoryNav);
})();
